import { createSlice } from '@reduxjs/toolkit';
import { fetchExpenses, fetchExpenseById, createExpense, fetchMonthlyExpenses, fetchMonthlyExpenseDetails, fetchUserExpenses } from '../thunks/expenseThunks';

const initialState = {
  expenses: [],
  monthlyExpenses: [],
  monthlyExpenseDetails: null,
  summary: null,
  pagination: null,
  selectedExpense: null,
  loading: false,
  error: null,
  success: false,
  userExpenses: []
};

const expenseSlice = createSlice({
  name: 'expenses',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    clearSuccess: (state) => {
      state.success = false;
    },
    clearCurrentExpense: (state) => {
      state.currentExpense = null;
    },
    clearExpenses: (state) => {
      state.expenses = [];
    },
    clearUserExpenses: (state) => {
      state.userExpenses = [];
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch Expenses
      .addCase(fetchExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.expenses = action.payload?.data?.dailyExpenses || [];
      })
      .addCase(fetchExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Expense by ID
      .addCase(fetchExpenseById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchExpenseById.fulfilled, (state, action) => {
        state.loading = false;
        state.currentExpense = action.payload.data;
      })
      .addCase(fetchExpenseById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Create Expense
      .addCase(createExpense.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createExpense.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
      })
      .addCase(createExpense.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Monthly Expenses
      .addCase(fetchMonthlyExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyExpenses = action.payload.data.monthlyExpenses;
        state.summary = action.payload.data.summary;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchMonthlyExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch Monthly Expense Details
      .addCase(fetchMonthlyExpenseDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyExpenseDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.monthlyExpenseDetails = {
          ...(action.payload.data.monthlyExpense || {}),
          pendingApprovalRequest: action.payload.data.pendingApprovalRequest,
        };
      })
      .addCase(fetchMonthlyExpenseDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Fetch User Expenses
      .addCase(fetchUserExpenses.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUserExpenses.fulfilled, (state, action) => {
        state.loading = false;
        state.userExpenses = action.payload.data.dailyExpenses || [];
      })
      .addCase(fetchUserExpenses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setLoading, setError, clearError, clearSuccess, clearCurrentExpense, clearExpenses, clearUserExpenses } = expenseSlice.actions;
export default expenseSlice.reducer; 
